import { NonBFIExperienceActionsButton } from '../ExperienceComponents';

export const onNonBFIExperienceActionCellRender = (e) => {
    return <NonBFIExperienceActionsButton experience={e.data} />;
};
